<template>
	<div class="button blue--text" :class="{double: double, secondary: secondary}" @mouseenter="hover">
		<span>{{value}}</span>
	</div>
</template>

<script>

export default {
	props: ['value', 'double','secondary'],
	methods: {
		hover() {
			this.playAudio('hover');
		}
	}
}
</script>
<style scoped lang="scss">
	.button {
		display: block;
		text-align: center;
		cursor: pointer;
		font-size: px(18);
		padding: px(12.5) px(20);
		text-transform: uppercase;
		border-radius: px(40);
		position: relative;
		overflow: hidden;
		background: $mondadori-yellow;

		&.secondary {
			background: #5a97f7 !important;
			font-size: $xs;
			color: white !important;
			padding: px(5);
		}

		::selection {
			background: transparent;
		}
		span {
			z-index: 1;
			position: relative;
		}
		
		&:before {
			content: '';
			opacity: 0.6;
			position: absolute;
			width: 0%;
			height: 100%;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
			z-index: 0;
			background: #fff;
			transition: width 0.15s;
		}
		&:hover {
			&:before {
				width: 100%;
			}
		}
		
	}
</style>